import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AdminService } from '../../../core/services/core.admin.service';
import { StateService } from '@uirouter/angular';

import * as _ from 'lodash';

@Component({
    selector: 'trove-projects',
    template: require('./trove.projects.component.html')
})
export class TroveProjectsComponent implements OnChanges {

    @Input() category: any = null;

    protected projects: any = null;

    constructor(
        private adminService: AdminService,
        public stateService: StateService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.projects = false;
        this.adminService.troveProjects(_.get(this.category, 'id', 0))
        .then((ret) => {
            this.projects = _.get(ret, 'items', []);
        }, (response) => {
            console.log(response);
            this.projects = [];
        });
    }
}